import css from "./platforms.module.scss";
import { Layout } from "../../componentsV1/layout";
import { Pill } from "../../componentsV1/Pill";
import { Card } from "../../componentsV1/Card";
import Logo from "../../assets/v1/logo.png";
import { Antibody, Stack, Graph, Target, Validation } from "../../assets/v1/icons";

export const Platforms = () => {

  const steps = ["WB", "Widefield", "WF-SIM", "Confocal", "Airyscan", "SIM", "SIM²", "STORM"];


  const services = [
    {
      heading: "Rapid Validation",
      description: "Western blot validation, widefield/confocal imaging, and initial localization assessment for quick confidence in target performance.",
      otherText: "Typical timeline: 3–7 days",
      price: "$3K – $8K"
    },
    {
      heading: "Stepdown Analysis",
      description: "Full workflow from WB through SIM, with ROI analysis, structured interpretation, and resolution-aware biological conclusions.",
      otherText: "Typical timeline: 1–3 weeks",
      price: "$10K – $25K"
    },
    {
      heading: "Nanoscale Programs",
      description: "Full stepdown plus STORM, multiplex integration, and high-confidence nanoscale analysis for mechanistic or publication-grade studies.",
      otherText: "Typical timeline: 2–4+ weeks",
      price: "$25K+"
    }
  ]

  const logos = [
    {
      icon: Target,
      text: "Resolution Aware"
    },
    {
      icon: Stack,
      text: "Systematic Progression"
    },
    {
      icon: Validation,
      text: "Biologically Validated"
    },
    {
      icon: Graph,
      text: "Actionable Insights"
    }
  ]


  return (
    <Layout>
      <div className={css.heroContainer}>
        <div className={css.heroContent}>
            <img src={Logo} alt="logo" className={css.heroLogo} />
            <div className={css.heroText}>
            <h4>MICROSCOPY PLATFORM</h4>
            <div className={css.line} />
            <h1>PRECISION IMAGING ACROSS EVERY SCALE—FROM WIDEFIELD TO <span>SUPER-RESOLUTION—</span>INTEGRATED INTO A SINGLE HIGH PERFORMANCE <span>MICROSCOPY STACK.</span></h1>
            </div>
             <div className={css.logoContainer}>
              {logos.map((item) => {
              return (
              <div className={css.logo}>
                <img src={item.icon} alt={item.text} />
                <p>{item.text}</p>
              </div>
              )})
              }
            </div>
        </div>
      </div>
      <div className={css.container}>
        <div className={css.columnSection}>
          <Card heading={'Imaging Systems'} className={css.columnCard}>
            <h2>Zeiss</h2>
            <p>Advanced confocal, Airyscan, and structured illumination workflows that support reproducible acquisition and high-confidence spatial interpretation.</p>
            <div className={css.pillsContainer}>
              {['Confocal', 'Airyscan', 'SIM / SIM²', 'High-end optical workflows'].map((item) => {
                return <Pill text={item} />
              })}
            </div>
          </Card>
          <Card heading={'Nanoscale Resolution'} className={css.columnCard}>
            <h2>Bruker</h2>
            <p>Nanoscale imaging platforms that extend beyond diffraction-limited interpretation and help define finer biological structure.</p>
            <div className={css.pillsContainer}>
              {['Super-resolution workflows', 'Nanoscale structural readout', 'Advanced platform integration', 'High-value discovery support'].map((item) => {
                return <Pill text={item} />
              })}
            </div>
          </Card>
          <Card heading={'Signal Systems'} className={css.columnCard}>
            <h2>Sapphire</h2>
            <p>A performance-oriented chemistry and signal framework designed to improve visibility, consistency, and downstream interpretability across demanding applications.</p>
            <div className={css.pillsContainer}>
              {['Signal optimization', 'Workflow enhancement', 'Application flexibility', 'Performance extension'].map((item) => {
                return <Pill text={item} />
              })}
            </div>
          </Card>
          <Card heading={'Fluorophore Chemistry'} className={css.columnCard}>
            <h2>Aquifluor</h2>
            <p>Fluorescence chemistry designed to support stronger product differentiation, broader instrument compatibility, and higher-value imaging outcomes.</p>
            <div className={css.pillsContainer}>
              {['Expanded color strategy', 'Instrument compatibility', 'Direct conjugate enablement', 'Commercial visibility'].map((item) => {
                return <Pill text={item} />
              })}
            </div>
          </Card>
        </div>
        <section className={css.sectionBg}>
          <div className={css.columnSection2}>
            <div className={css.columnCard}>
              <h3 className={css.subHeading}>Why this platform stack matters</h3>
              <h2 className={css.heading}>The stepdown defines the logic. These platforms provide the power behind it.</h2>
              <p>We separate the explanatory framework from the hardware and chemistry stack. The Stepdown page explains how interpretation works. This page shows the technology brands and systems that make those workflows possible.</p>
            </div>
            <Card heading={'Platform outcome'}>
              <ul className={css.list}>
              <li>Premium instrumentation credibility</li>
              <li>Clearer commercial positioning</li>
              <li>Stronger connection between chemistry and imaging</li>
              <li>Better visibility for future product families</li>
            </ul>
            </Card>
          </div>
        </section>
      </div>
    </Layout>
  );
}